import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: theme.spacing(4),
    padding: theme.spacing(2, 5),
    backgroundColor: theme.palette.text.white,
    boxShadow: `0px -1px 0px 0px ${theme.palette.labraV2BoxShadow.dark} inset`,
    position: 'sticky',
    zIndex: 99,
    top: 0,
  },
  appTitleHeading: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: 'fit-content',
  },
  appBackIcon: {
    display: 'flex',
    margin: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
  appTitleHeadingText: {
    fontSize: '28px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '36px',
    color: theme.palette.labraText.primary,
  },
  root: {
    padding: theme.spacing(4, 5),
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
  rightContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 110px)',
    gap: theme.spacing(3),
  },
  stickyStatusListing: {
    position: 'sticky',
    top: theme.spacing(10.75),
    zIndex: 1,
  },
  section: {
    width: '100%',
    paddingTop: theme.spacing(1),
    marginBottom: theme.spacing(-2),
  },
  customWrapper: {
    width: '100%',
    display: 'flex',
    gap: theme.spacing(1),
  },
  dateWrapper: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  dateValue: {
    fontSize: '16px',
    color: theme.palette.textField.dark,
    lineHeight: theme.spacing(3),
  },
  timeValue: {
    fontSize: '14px',
    color: theme.palette.labraText.description,
    lineHeight: theme.spacing(2.5),
  },
  rightSection: {
    padding: `${theme.spacing(2, 3)}`,
  },
  editActionLabel: {
    display: 'flex',
    alignItems: 'center',
  },
  disabledEdit: {
    opacity: '39%',
  },
  metadata: {
    width: '100%',
    paddingTop: theme.spacing(3),
  },
}))
